export default __webpack_public_path__ + "static/media/virtual-mouse-keyboard.ab040d9f.png";